import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import {
    AccountCircleTwoTone, AddCircleOutline, AutoGraphTwoTone, CurrencyExchangeTwoTone,
    ForumTwoTone, HelpTwoTone, LocalOfferTwoTone, LoginTwoTone, LogoutTwoTone,
    PriceCheckTwoTone, RemoveCircleOutline, SmartToyTwoTone, StarBorderTwoTone,
    StorageTwoTone, VerifiedTwoTone, Grading
} from "@mui/icons-material";
import Cookies from "js-cookie";
import { IconButton, Tooltip, Typography } from "@mui/material";
import axios from "axios";
import PerformanceMachines from "./PerformanceMachines";
import ListedMachines from "./ListedMachines";
import LicensedMachines from "./LicensedMachines";
import ListedMachinePrefs from "./ListedMachinePrefs";


export default function Evo4() {
    const [authToken, setAuthToken] = useState("");
    const [userData, setUserData] = useState([]);
    const [numSessions, setNumSessions] = useState(0);
    const [showSmallToolbar, setShowSmallToolbar] = useState(false);
    const [iframeSource, setIframeSource] = useState("/analytics/login");
    const [showWovenPanel, setShowWovenPanel] = useState(true);
    const [selectedSection, setSelectedSection] = useState("offers");
    const [numPerfMachines, setNumPerfMachines] = useState(0);
    const [agentSection, setAgentSection] = useState("listings"); // Tracks listings, licensed, or events

    const reloadIframe = async () => {
        console.log("reloadIframe() called");
        const iframe = document.getElementById('evo3Iframe');
        if (numPerfMachines > 0) {
            if (iframe) {
                iframe.style.display = "";
                iframe.src += '';
            }
        } else {
            if (iframe) {
                iframe.style.display = "none";
            }
        }
    };

    useEffect(() => {
        const checkViewWidth = () => {
            const viewWidth = document.getElementById('appViewHolder').offsetWidth;
            setShowSmallToolbar(viewWidth < 1150);
        };
        const auth = Cookies.get('auth');
        const email = Cookies.get('email');
        const sessionStatus = Cookies.get('woven_session');
        console.log("-> useEffect() auth " + auth + " email " + email + " sessionStatus " + sessionStatus);

        const run = async () => {
            if (auth && email) {
                setAuthToken(auth);
                const userData = await refreshSession(email);
                if (sessionStatus === "authenticated") {
                    console.log("useEffect() : authenticated");
                    await handleSectionSwitch(Cookies.get("analytics_section"), agentSection, userData);
                } else if (userData.enabled) {
                    const expirationTime = new Date(new Date().getTime() + (60000 * 60 * 168));
                    await setIframeSource("/analytics/login");
                    let intervalId;
                    intervalId = setInterval(() => {
                        const iframe = document.getElementById('evo3Iframe');
                        console.log("useEffect() polling login ");
                        if (iframe && iframe.contentWindow) {
                            try {
                                const currentUrl = iframe.contentWindow.location.href;
                                if (!currentUrl.endsWith("/analytics/login")) {
                                    clearInterval(intervalId);
                                    Cookies.set('woven_session', 'authenticated', { expires: expirationTime });
                                    const newSession = Cookies.get('woven_session');
                                    console.log("useEffect(authUser(refreshSession())) new session " + newSession);
                                    handleSectionSwitch(Cookies.get("analytics_section"), agentSection, userData);
                                }
                            } catch (e) {
                                // Ignore cross-origin errors (should not happen if same-origin)
                            }
                        }
                    }, 1000); // Poll every second
                }
            } else {
                console.log("useEffect() : anonymous user");
                setIframeSource("/analytics/d/prod-community-live-offers/offers?orgId=1");
            }
        };

        run();

        window.addEventListener('resize', checkViewWidth);
        checkViewWidth(); // Initial check
        return () => window.removeEventListener('resize', checkViewWidth);
    }, []);

    const handleSectionSwitch = async (analyticsSection, agentSection, userData) => {
        console.log("handleSectionSwitch() analyticsSection: " + analyticsSection + ", agentSection: " + agentSection);
        if(analyticsSection === "agent") {
            handleAgentSection(agentSection, userData);
        } else if(analyticsSection === "offers") {
            handleOffers(userData);
        } else if(analyticsSection === "machines") {
            handleMachines(userData);
        } else if(analyticsSection === "performance") {
            handlePerformance(userData);
        } else if(analyticsSection === "verified") {
            handleVerified(userData);
        } else if(analyticsSection === "estimate") {
            handleEstimate(userData);
        }
    }

    // API functions (unchanged from previous)
    const authUser = async (authToken) => {
        const encodedAuthToken = encodeURIComponent(authToken);
        try {
            const response = await fetch('/api/user/auth?token=' + encodedAuthToken, {
                method: 'GET'
            });
            if (response.ok) {
                await response.json();
            } else {
                handleOffers();
            }
        } catch (error) {
            window.location.href = '/login';
        }
    };

    const refreshSession = async (email) => {
        console.log("refreshSession() email " + email);
        try {
            const response = await fetch("/api/user/getUser?email=" + email, {
                method: 'GET'
            });
            console.log("refreshSession() response.ok " + response.ok);
            if (response.ok) {
                const sessionData = await response.json();
                setUserData(sessionData);
                return sessionData;
            }
        } catch (error) {
            return null;
        }
    };

    const fetchUserGrafanaSessions = async (token) => {
        const formData = new URLSearchParams();
        formData.append('token', token);
        try {
            const response = await axios.post('/api/grafana/getUserSessions', formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
            if (response.status >= 200 && response.status < 300) {
                const sessions = response.data;
                return sessions;
            }
            return 0;
        } catch (error) {
            console.error("Error in fetchUserGrafanaSessions:", error);
            return 0;
        }
    };

    const fetchNumPerfMachines = async (authToken) => {
        try {
            const response = await fetch("/api/perf/getMachines?token=" + encodeURIComponent(authToken), {
                method: 'GET'
            });
            if (response.ok) {
                const machines = await response.json();
                return machines.filter(machine => machine.enabled).length;
            } else {
                return 0;
            }
        } catch (error) {
            console.error("Error in fetchNumPerfMachines:", error);
            return 0;
        }
    };

    const logoutGrafanaUser = async () => {
        const formData = new URLSearchParams();
        formData.append('token', authToken);
        try {
            const response = await axios.post('/api/grafana/logoutUser', formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
            if (response.status >= 200 && response.status < 300) {
                const sessions = response.data;
                return sessions;
            }
            return 0;
        } catch (error) {
            console.error("Error with logout:", error);
            return 0;
        }
    };

    const handleLogout = () => {
        Cookies.remove("auth");
        Cookies.remove("email");
        Cookies.remove("analytics_section");
        Cookies.remove("woven_session");
        logoutGrafanaUser().then();
        window.location.href = './login';
    };

    //TODO:  Implement steel navigation

    const handleOffers = (userData) => {
        console.log("handleOffers session.enabled " + userData.enabled + " session.subscription " + userData.subscription);
        if (userData.enabled) {
            const source =
                userData.subscription === "steel" ?
                    "/analytics/d/c88ff11a-9a5a-4e45-9a05-2125e471d197/offers-deep-dive?orgId=1" :
                userData.subscription === "aluminium" ?
                    "/analytics/d/e6c785a6-ad92-4a60-81e5-db5319a36f3b/offers?orgId=1" :
                userData.subscription === "titanium" || userData.subscription === "inconel" ?
                    "/analytics/d/c0dfd4fd-2483-4fe6-af87-3a9ceb36e0f1/offers?orgId=1" :
                    "/analytics/d/prod-community-live-offers/offers?orgId=1";
            Cookies.set("analytics_section", "offers");
            setSelectedSection("offers");
            setIframeSource(source);
        } else {
            setIframeSource("/analytics/d/c88ff11a-9a5a-4e45-9a05-2125e471d197/offers-deep-dive?orgId=1");
        }
    };

    const handleMachines = (userData) => {
        if (userData.enabled) {
            const source =
                userData.subscription === "steel" ?
                    "/analytics/d/c277c9e7-df2f-4f8a-acb5-c4c8301bea22/machines?orgId=1" :
                userData.subscription === "aluminium" ?
                    "/analytics/d/c208016e-a8e0-45f8-8d43-bef20b650620/machines?orgId=1" :
                userData.subscription === "titanium" || userData.subscription === "inconel" ?
                "/analytics/d/a06ce580-305a-4e39-bd50-76098189d173/machines?orgId=1" :
                "/analytics/d/prod-community-live-machines/machines?orgId=1";
            Cookies.set("analytics_section", "machines");
            setSelectedSection("machines");
            setIframeSource(source);
        } else {
            setIframeSource("/analytics/d/c277c9e7-df2f-4f8a-acb5-c4c8301bea22/machines?orgId=1");
        }
    };

    const handlePerformance = (userData) => {
        console.log("handlePerformance: " + agentSection + " session.enabled " + userData.enabled
            + " session.subscription " + userData.subscription);
        if (userData.enabled) {
            const source =
                userData.subscription === "steel" ?
                    "/analytics/d/f48275c3-5984-4b30-9a6b-5b5a97247661/performance?orgId=1" :
                userData.subscription === "aluminium" ?
                    "/analytics/d/aa27955b-8129-48e0-8b33-92928b32a3b4/performance-favorites?orgId=1&var-userId=" + userData.id :
                userData.subscription === "titanium" || userData.subscription === "inconel" ?
                    "/analytics/d/c7c2873f-3c05-4900-b0b5-fa8af3961803/performance-favorites?orgId=1&var-userId=" + userData.id :
                    "/analytics/d/prod-com-live-mac-cfg-offers/performance?orgId=1";
            console.log("handlePerformance: source " + source);

            Cookies.set("analytics_section", "performance");
            setSelectedSection("performance");

            if(userData.subscription === "aluminium" || userData.subscription === "titanium" || userData.subscription === "inconel" ) {
                const numMachines = fetchNumPerfMachines(authToken ? authToken : Cookies.get("auth")).then(numMachines => {
                    console.log("Fetched number of performance machines: " + numMachines);
                    console.log("handlePerformance: " + agentSection + " numMachines " + numMachines);
                    setNumPerfMachines(numMachines);
                    setIframeSource(source);
                });
            } else {
                setNumPerfMachines(0);
                setIframeSource(source);
            }
        } else {
            setIframeSource("analytics/d/f48275c3-5984-4b30-9a6b-5b5a97247661/performance?orgId=1");
        }
    };

    const handleAgentSection = (agentSection, userData) => {
        console.log("handleAgentSection: " + agentSection + " userData.enabled " + userData.enabled
            + " userData.subscription " + userData.subscription);
        if(userData.enabled) {
            if (!userData.enabled || userData.subscription !== "inconel") {
                window.location.href = "../profile";
            } else if (userData.subscription === "inconel") {
                Cookies.set("analytics_section", "agent");
                Cookies.set("agent_section", agentSection);
                setSelectedSection("agent");
                setAgentSection(agentSection);
            }
        } else {
            window.location.href = "/register";
        }
    };

    const handleListingCtx = (userData) => {
        console.log("handleListingCtx: session.enabled " + userData.enabled
            + " session.subscription " + userData.subscription);
        if(userData.enabled) {
            if (!userData.enabled || userData.subscription !== "inconel") {
                window.location.href = "../profile";
            } else if (userData.subscription === "inconel") {
                Cookies.set('analytics_section', 'listings');
                setSelectedSection("listings");
                const source = "/analytics/d/c45a1170-9f8d-4203-98b4-9cf0fd194651/listing-context?orgId=1&var-userId=" + userData.id;
                setIframeSource(source);
            }
        } else {
            window.location.href = "/register";
        }
    };

    const handleVerified = (userData) => {
        console.log("handleVerifed:  session.enabled " + userData.enabled + " session.subscription " + userData.subscription);
        if(userData.enabled) {
            const source = userData.subscription === "aluminium" ?
                "/analytics/d/ee0a9c59-daad-48b1-a80f-3da0b02236e7/verified" :
                userData.subscription === "titanium" || userData.subscription === "inconel" ?
                    "/analytics/d/d37a5032-4735-4214-abde-b040e77a1576/verified?orgId=1" :
                    "/register";
                Cookies.set("analytics_section", "verified");
                setSelectedSection("verified");
                setIframeSource(source);
        } else {
            window.location.href = "/register";
        }
    };

    const handleEstimate = (userData) => {
        const source = userData.subscription === "aluminium" || userData.subscription === "titanium" || userData.subscription === "inconel" ?
                "/analytics/d/d7411b23-ef56-4cbb-98bc-7003e0dbb12b/estimate?orgId=1" :
                "/register";
        if (!authToken || !userData.enabled) {
            window.location.href = "/register";
        } else {
            Cookies.set("analytics_section", "estimate");
            setSelectedSection("estimate");
            setIframeSource(source);
        }
    };

    const handleCommunity = () => {
        window.location.href = 'https://discord.gg/63xuhRTWrw';
    };

    const handleHelp = () => {
        window.location.href = '/web/index.html#overview';
    };

    const togglePerformanceMachines = () => {
        setShowWovenPanel(prevState => !prevState);
    };

    const handleSwitchToLicensed = () => {
        Cookies.set("agent_section", "licensed");
        setAgentSection("licensed");
    };

    const handleSwitchToEvents = () => {
        setAgentSection("events");
    };

    const handleSwitchToListings = () => {
        setAgentSection("listings");
    };

    const handleShowInstallation = () => {
        console.log('handleShowInstallation called', { authToken, enabled: userData.enabled, subscription: userData.subscription });
        if (authToken && userData.enabled && userData.subscription === "inconel") {
            const url = `../../installation.html?token=${encodeURIComponent(authToken)}`;
            console.log('Setting iframeSource to:', url);
            setIframeSource(url);
        } else {
            console.log('Redirecting to register due to invalid conditions');
            window.location.href = "../register";
        }
    };

    return (
        <div id="appViewHolder" className="AppViewHolder">
            {showSmallToolbar ? (
                <div id="toolbarSmall" className="Toolbar">
          <span className="ButtonHolder">
            <Tooltip title="Offers">
              <IconButton
                  size="small"
                  sx={{ color: selectedSection === "offers" ? theme => theme.palette.primary.light : theme => theme.palette.primary.dark }}
                  onClick={() => handleOffers(userData)}
              >
                <LocalOfferTwoTone />
              </IconButton>
            </Tooltip>
          </span>
                    <span className="ButtonHolder">
            <Tooltip title="Machines">
              <IconButton
                  size="small"
                  sx={{ color: selectedSection === "machines" ? theme => theme.palette.primary.light : theme => theme.palette.primary.dark }}
                  onClick={() => handleMachines(userData)}
              >
                <StorageTwoTone />
              </IconButton>
            </Tooltip>
          </span>
                    <span className="ButtonHolder">
            <Tooltip title="Performance">
              <IconButton
                  size="small"
                  sx={{ color: selectedSection === "performance" ? theme => theme.palette.primary.light : theme => theme.palette.primary.dark }}
                  onClick={() => handlePerformance(userData)}
              >
                <AutoGraphTwoTone />
              </IconButton>
            </Tooltip>
          </span>
                    <span className="ButtonHolder">
            <Tooltip title="Agent">
              <IconButton
                  size="small"
                  sx={{ color: selectedSection === "agent" ? theme => theme.palette.primary.light : theme => theme.palette.primary.dark }}
                  onClick={() => handleAgentSection(agentSection, userData)}
              >
                <SmartToyTwoTone />
              </IconButton>
            </Tooltip>
          </span>
                    <span className="ButtonHolder">
            <Tooltip title="Listings">
              <IconButton
                  size="small"
                  sx={{ color: selectedSection === "listings" ? theme => theme.palette.primary.light : theme => theme.palette.primary.dark }}
                  onClick={() => handleListingCtx(userData)}
              >
                <Grading />
              </IconButton>
            </Tooltip>
          </span>
                    <span className="ButtonHolder">
            <Tooltip title="Verified">
              <IconButton
                  size="small"
                  sx={{ color: selectedSection === "verified" ? theme => theme.palette.primary.light : theme => theme.palette.primary.dark }}
                  onClick={() => handleVerified(userData)}
              >
                <VerifiedTwoTone />
              </IconButton>
            </Tooltip>
          </span>
                    <span className="ButtonHolder">
            <Tooltip title="Estimate">
              <IconButton
                  size="small"
                  sx={{ color: selectedSection === "estimate" ? theme => theme.palette.primary.light : theme => theme.palette.primary.dark }}
                  onClick={() => handleEstimate(userData)}
              >
                <PriceCheckTwoTone />
              </IconButton>
            </Tooltip>
          </span>
                    <span className="ButtonHolder">
            <Tooltip title="Community">
              <IconButton size="small" sx={{ color: theme => theme.palette.primary.dark }} onClick={() => handleCommunity()}>
                <ForumTwoTone />
              </IconButton>
            </Tooltip>
          </span>
                    <span className="ButtonHolder">
            <Tooltip title="Help">
              <IconButton color="primary" size="small" sx={{ color: theme => theme.palette.primary.dark }} onClick={() => handleHelp()}>
                <HelpTwoTone />
              </IconButton>
            </Tooltip>
          </span>
                    <span className="ButtonHolder">
            {authToken ? (
                <Tooltip title="Logout">
                    <IconButton color="secondary" size="small" onClick={handleLogout}>
                        <LogoutTwoTone />
                    </IconButton>
                </Tooltip>
            ) : (
                <Link to="/profile">
                    <Tooltip title="Login">
                        <IconButton color="success" size="small">
                            <LoginTwoTone />
                        </IconButton>
                    </Tooltip>
                </Link>
            )}
          </span>
                    {authToken && (
                        <span className="ButtonHolder">
              <Link to="/profile">
                <Tooltip title="Profile">
                  <IconButton color="success" size="small">
                    <AccountCircleTwoTone />
                  </IconButton>
                </Tooltip>
              </Link>
            </span>
                    )}
                </div>
            ) : (
                <div id="toolbarFull" className="Toolbar">
          <span className="ButtonHolder">
            <Button
                size="medium"
                startIcon={<LocalOfferTwoTone />}
                sx={{ color: selectedSection === "offers" ? theme => theme.palette.primary.light : theme => theme.palette.primary.dark }}
                onClick={() => handleOffers(userData)}
            >
              Offers
            </Button>
          </span>
                    <span className="ButtonHolder">
            <Button
                size="medium"
                startIcon={<StorageTwoTone />}
                sx={{ color: selectedSection === "machines" ? theme => theme.palette.primary.light : theme => theme.palette.primary.dark }}
                onClick={() => handleMachines(userData)}
            >
              Machines
            </Button>
          </span>
                    <span className="ButtonHolder">
            <Button
                size="medium"
                startIcon={<AutoGraphTwoTone />}
                sx={{ color: selectedSection === "performance" ? theme => theme.palette.primary.light : theme => theme.palette.primary.dark }}
                onClick={() => handlePerformance(userData)}
            >
              Performance
            </Button>
          </span>
                    <span className="ButtonHolder">
            <Button
                size="medium"
                startIcon={<SmartToyTwoTone />}
                sx={{ color: selectedSection === "agent" ? theme => theme.palette.primary.light : theme => theme.palette.primary.dark }}
                onClick={() => handleAgentSection(agentSection, userData)}
            >
              Agent
            </Button>
          </span>
                    <span className="ButtonHolder">
            <Button
                size="medium"
                startIcon={<Grading />}
                sx={{ color: selectedSection === "listings" ? theme => theme.palette.primary.light : theme => theme.palette.primary.dark }}
                onClick={() => handleListingCtx(userData)}
            >
              Listings
            </Button>
          </span>
                    <span className="ButtonHolder">
            <Button
                size="medium"
                startIcon={<VerifiedTwoTone />}
                sx={{ color: selectedSection === "verified" ? theme => theme.palette.primary.light : theme => theme.palette.primary.dark }}
                onClick={() => handleVerified(userData)}
            >
              Verified
            </Button>
          </span>
                    <span className="ButtonHolder">
            <Button
                size="medium"
                startIcon={<PriceCheckTwoTone />}
                sx={{ color: selectedSection === "estimate" ? theme => theme.palette.primary.light : theme => theme.palette.primary.dark }}
                onClick={() => handleEstimate(userData)}
            >
              Estimate
            </Button>
          </span>
                    <span className="ButtonHolder">
            <Tooltip title="Community">
              <IconButton size="small" sx={{ color: theme => theme.palette.primary.dark }} onClick={() => handleCommunity()}>
                <ForumTwoTone />
              </IconButton>
            </Tooltip>
          </span>
                    <span className="ButtonHolder">
            <IconButton color="primary" size="small" sx={{ color: theme => theme.palette.primary.dark }} onClick={() => handleHelp()}>
              <HelpTwoTone />
            </IconButton>
          </span>
                    <span className="ButtonHolder">
            {authToken ? (
                <IconButton color="secondary" size="small" onClick={handleLogout}>
                    <LogoutTwoTone />
                </IconButton>
            ) : (
                <Link to="/login">
                    <Button variant="outlined" color="success" size="medium" startIcon={<LoginTwoTone />}>
                        LOGIN / SUBSCRIBE
                    </Button>
                </Link>
            )}
          </span>
                    {authToken && (
                        <span className="ButtonHolder">
              <Link to="/profile">
                <Button variant="text" color="success" size="medium" startIcon={<AccountCircleTwoTone />}>
                  {userData.screenName}
                </Button>
              </Link>
            </span>
                    )}
                </div>
            )}
            {(selectedSection === "performance" && (userData.subscription === "aluminium" || userData.subscription === "titanium" || userData.subscription === "inconel")) && (
                <div>
                    <div className="subToolbar">
                        <div className="subToolbarItems">
                            <IconButton onClick={togglePerformanceMachines} color="primary" size="small">
                                {showWovenPanel ? <RemoveCircleOutline /> : <AddCircleOutline />}
                            </IconButton>
                            <StarBorderTwoTone className="iconWhite" />
                            <Typography variant="button" className="textWhite">
                                Favorites
                            </Typography>
                        </div>
                    </div>
                    <div>
                        {showWovenPanel && (
                            <PerformanceMachines onAction={reloadIframe} />
                        )}
                    </div>
                    <div>
                        {numPerfMachines > 0 &&
                            <iframe
                                id="evo3Iframe"
                                src={iframeSource}
                                title="Woven Dashboards"
                                className="AppIFrame"
                                style={{ minHeight: showWovenPanel ? '75vh' : '90vh' }}
                            />
                        }
                    </div>
                </div>
            )}
            {(selectedSection === "performance" && userData.subscription === "steel") && (
                <div>
                    <div>
                        <iframe
                            id="evo3Iframe"
                            src={iframeSource}
                            title="Woven Dashboards"
                            className="AppIFrame"
                            style={{ minHeight: showWovenPanel ? '75vh' : '90vh' }}
                        />
                    </div>
                </div>
            )}
            {(selectedSection === "agent" && userData.subscription === "inconel") && (
                <div>
                    <div className="subToolbar">
                        <div className="subToolbarItems">
                            <IconButton onClick={togglePerformanceMachines} color="primary" size="small">
                                {showWovenPanel ? <RemoveCircleOutline /> : <AddCircleOutline />}
                            </IconButton>
                            <StarBorderTwoTone className="iconWhite" />
                            <Typography variant="button" className="textWhite">
                                {agentSection.toUpperCase()}
                            </Typography>
                        </div>
                    </div>
                    <div>
                        {showWovenPanel && (
                            agentSection === "licensed" ? (
                                <LicensedMachines
                                    onAction={reloadIframe}
                                    onSwitchToListings={handleSwitchToListings}
                                />
                            ) : agentSection === "events" ? (
                                <ListedMachinePrefs
                                    onAction={reloadIframe}
                                    onSwitchToListings={handleSwitchToListings}
                                />
                            ) : (
                                <ListedMachines
                                    onAction={reloadIframe}
                                    onSwitchToLicensed={handleSwitchToLicensed}
                                    onSwitchToEvents={handleSwitchToEvents}
                                />
                            )
                        )}
                    </div>
                </div>
            )}
            <div>
                {(selectedSection === "offers" || selectedSection === "machines" || selectedSection === "listings" ||
                    selectedSection === "verified" || selectedSection === "estimate") && (
                    <iframe
                        id="evo3Iframe"
                        src={iframeSource}
                        title="Woven Dashboards"
                        className="AppIFrame"
                    />
                )}
            </div>
        </div>
    );
}